module.exports = __webpack_public_path__ + "static/media/map-icon.01f53aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-icon.png
// module id = 1260
// module chunks = 0